import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotTubCareComponent } from './hot-tub-care.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { HotTubCareRoutingModule } from './hot-tub-care-routing.module';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    NgxSpinnerModule,
    HotTubCareRoutingModule,
    ReactiveFormsModule,
    HotTubCareComponent
]
})
export class HotTubCareModule { }
